var React = require('react');

function ComputerScreen (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fill":"#FFFFFF","d":"M318.753,76.373l57.846-0.003V0H0v213.726h285.499c0-34.695-0.003-69.392,0-104.087\r\n\t\tC285.501,87.879,296.999,76.376,318.753,76.373z"})));
}

ComputerScreen.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"376.599px","height":"213.726px","viewBox":"0 0 376.599 213.726","enableBackground":"new 0 0 376.599 213.726","xmlSpace":"preserve"};

module.exports = ComputerScreen;

ComputerScreen.default = ComputerScreen;
